import React from "react";
import {ProgressBar, Wrapper} from "./CustomProgress.styles";
export const CustomProgress = ({
    progress = 0,
    primaryColor = "#d6ff01",
    secondaryColor = "#f2a19f",
    height
}) => {
    return (
        <Wrapper height={height}>
            <ProgressBar progress={progress} backgroundColor={primaryColor} />

            <ProgressBar
                progress={100 - progress}
                backgroundColor={progress <= 50 ? secondaryColor : primaryColor}
            />
        </Wrapper>
    );
};
